export default "__VITE_ASSET__BhxAdpYs__"